import {useCSRFToken} from '@github-ui/use-csrf-token'
import {createContext, type PropsWithChildren, use} from 'react'

export const NOTIFICATION_SUBSCRIPTION_PATH = '/notifications/thread'

const NotificationSubscriptionCsrfTokenContext = createContext<string | undefined>(undefined)

export function NotificationSubscriptionCsrfTokenProvider({
  token,
  children,
}: PropsWithChildren<{token: string | undefined}>) {
  return <NotificationSubscriptionCsrfTokenContext value={token}>{children}</NotificationSubscriptionCsrfTokenContext>
}

export function LegacyNotificationSubscriptionCsrfTokenProvider({children}: PropsWithChildren) {
  const token = useCSRFToken(NOTIFICATION_SUBSCRIPTION_PATH, 'post')

  return <NotificationSubscriptionCsrfTokenProvider token={token}>{children}</NotificationSubscriptionCsrfTokenProvider>
}

export function useNotificationSubscriptionCsrfToken() {
  return use(NotificationSubscriptionCsrfTokenContext)
}
